import lodash from "lodash";
import { getLocalStorageData, setLocalStorageData } from "../../utils/utils";

export default {

  name: "newCoachingTableSettingsModule",
  namespaced: true,
  state: {
    tableSettingsStorageKey: "new.coaching.table.settings",

    newPageIndex: 1,

    newPageSize: 25,
    newSort: {
      sortBy: [],
      sortDesc: [],
    },

    defaultSettings: {
      newPageSize: 25,
      newSort: {
        sortBy: [],
        sortDesc: [],
      },
    },
  },

  mutations: {
    changeSettings(state, data) {
      state.newPageIndex = data.index;
      state.newPageSize = data.size;
      state.newSort = data.sort;
    },

    saveSettings(state) {
      const data = {
        newPageSize: state.newPageSize,
        newSort: state.newSort,
      };
      setLocalStorageData(state.tableSettingsStorageKey, JSON.stringify(data));
      state.defaultSettings = data;
    },

    applyDefaultSettings(state) {
      state.newSort = { ...state.defaultSettings.newSort };
      state.newPageSize = state.defaultSettings.newPageSize;
    },

    applyQuerySettings(state, query) {
      if (query.newPageIndex) {
        state.newPageIndex = +query.newPageIndex;
      }
      if (query.newPageSize) {
        state.newPageSize = +query.newPageSize;
      }
      if (query.newSort) {
        state.newSort = JSON.parse(query.newSort);
      }
    },
  },

  actions: {
    loadDefaultSettingsFromStorage({ state }) {
      const data = getLocalStorageData(state.tableSettingsStorageKey);
      if (data) {
        state.defaultSettings = JSON.parse(data);
      }
    },
  },

  getters: {
    isDefaultNewSettings: (state, getters) => getters.isDefaultNewSort && getters.isDefaultNewSize,
    isDefaultNewSort: (state) => lodash.isEqual(state.newSort, state.defaultSettings.newSort),
    isDefaultNewSize: (state) => state.newPageSize === state.defaultSettings.newPageSize,
  },
};
